export enum FreightFobTypes {
  Any = 'A',
  Pickup = 'P',
  Deliver = 'D'
}
